const ListSMIcon = ({ onClick }: { onClick: (val: 'sm') => void }) => {
  return (
    <svg
      width="32"
      height="32"
      onClick={() => {
        onClick('sm');
      }}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29 0H3C1.34312 0 0 1.34312 0 3V29C0 30.6569 1.34312 32 3 32H29C30.6569 32 32 30.6569 32 29V3C32 1.34312 30.6569 0 29 0ZM30 29C30 29.5523 29.5523 30 29 30H3C2.44769 30 2 29.5523 2 29V3C2 2.44769 2.44769 2 3 2H29C29.5523 2 30 2.44769 30 3V29Z"
        fill="black"
        fillOpacity="0.2"
      />
      <path
        d="M19.1103 16.2684C18.8974 16.0528 18.5537 16.0528 18.3409 16.2684L17.0859 17.5475L14.745 15.1617C14.5322 14.9461 14.1885 14.9461 13.9756 15.1617L10.156 19.0546C9.94507 19.2739 9.94844 19.626 10.1636 19.841C10.2637 19.941 10.3978 19.998 10.538 20H21.4512C21.7525 20.0018 21.9982 19.7543 22 19.4471C22.0008 19.2977 21.9427 19.1542 21.8386 19.049L19.1103 16.2684Z"
        fill="black"
        fillOpacity="0.2"
      />
      <path
        d="M17.5 15C18.3284 15 19 14.3284 19 13.5C19 12.6716 18.3284 12 17.5 12C16.6716 12 16 12.6716 16 13.5C16 14.3284 16.6716 15 17.5 15Z"
        fill="black"
        fillOpacity="0.2"
      />
    </svg>
  );
};

export default ListSMIcon;
